import React from 'react'
import { initialValues } from './AppointmentDrawerType'

export const AppointmentDrawerContext = React.createContext(initialValues)
export const AppointmentDrawerProvider = AppointmentDrawerContext.Provider
